import React, { useState, useEffect } from "react";
import axiosBase from "axios";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
import Time from "../components/time";
import { useParams, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import AdminNav from "../components/adminNav";

/* -------------------------- DEBUG HELPERS -------------------------- */
const LOG_NS = "veh-edit";
const log = (...args) => console.log(`[${LOG_NS}]`, ...args);
const warn = (...args) => console.warn(`[${LOG_NS}]`, ...args);
const err = (...args) => console.error(`[${LOG_NS}]`, ...args);

const perfMark = (name) => performance.mark(`${LOG_NS}:${name}`);
const perfMeasure = (label, start, end) => {
  try {
    performance.measure(`${LOG_NS}:${label}`, `${LOG_NS}:${start}`, `${LOG_NS}:${end}`);
    const entries = performance.getEntriesByName(`${LOG_NS}:${label}`);
    const last = entries[entries.length - 1];
    if (last) log(`${label} took ${Math.round(last.duration)} ms`);
  } catch (e) {}
};

/* ------------------------ AXIOS (with logs) ------------------------ */
const api = axiosBase.create({
  baseURL: "https://rfs2.infraconsoft.net.in/api",
  timeout: 20000, // client hard cap
});

// request log
api.interceptors.request.use((config) => {
  config.metadata = { start: Date.now() };
  log("HTTP →", config.method?.toUpperCase(), config.url, {
    params: config.params,
    data: config.data,
    timeout: config.timeout,
  });
  return config;
});

// response / error log
api.interceptors.response.use(
  (response) => {
    const ms = Date.now() - (response.config.metadata?.start || Date.now());
    log("HTTP ←", response.config.method?.toUpperCase(), response.config.url, `${ms}ms`, {
      status: response.status,
      data: response.data,
    });
    return response;
  },
  (error) => {
    const cfg = error.config || {};
    const ms = Date.now() - (cfg.metadata?.start || Date.now());
    err("HTTP ×", cfg.method?.toUpperCase(), cfg.url, `${ms}ms`, {
      code: error.code,
      message: error.message,
      status: error?.response?.status,
      data: error?.response?.data,
    });
    return Promise.reject(error);
  }
);

const Vehicle_details_edit1 = () => {
  useAuthRedirect();
  const { sno } = useParams();
  const navigate = useNavigate();

  const [branches, setBranches] = useState([]);
  const [vehicleType, setVehicleType] = useState([]);
  const [equip, setEquip] = useState([]);
  const user = localStorage.getItem("username");

  const [formData, setFormData] = useState({});

  /* ------------------------- INITIAL FETCHES ------------------------- */
  useEffect(() => {
    (async () => {
      try {
        perfMark("branches:start");
        const response = await api.get(`/get_branches`);
        setBranches(response.data.branches || []);
        perfMark("branches:end");
        perfMeasure("fetch branches", "branches:start", "branches:end");
      } catch (error) {
        err("fetch get_branches failed", error);
      }
    })();
  }, []);

  useEffect(() => {
    (async () => {
      try {
        perfMark("vtype:start");
        const response = await api.get(`/get_vType`);
        setVehicleType(response.data.vType || []);
        perfMark("vtype:end");
        perfMeasure("fetch vType", "vtype:start", "vtype:end");
      } catch (error) {
        err("fetch get_vType failed", error);
      }
    })();
  }, []);

  useEffect(() => {
    (async () => {
      try {
        perfMark("equip:start");
        const response = await api.get(`/get_vEquip`);
        setEquip(response.data.vEquip || []);
        perfMark("equip:end");
        perfMeasure("fetch vEquip", "equip:start", "equip:end");
      } catch (error) {
        err("fetch get_vEquip failed", error);
      }
    })();
  }, []);

  /* ------------------- LOAD EXISTING VEHICLE DETAILS ------------------ */
  useEffect(() => {
    const fetchStnDetails = async () => {
      try {
        log("loading vehicle_transfer_details for sno:", sno);
        await Swal.fire({
          title: "Fetching Vehicle Details",
          html: `
            <div style="width: 100%; background: #e0e0e0; border-radius: 5px;">
              <div style="height: 10px; width: 0%; background: linear-gradient(to right, #4facfe, #00f2fe); animation: progressBar 2s linear infinite;"></div>
            </div>
            <p style="margin-top: 10px; font-size: 14px;">Please wait while we fetch Vehicle Details...</p>
          `,
          showConfirmButton: false,
          allowOutsideClick: false,
          didOpen: () => {
            const style = document.createElement("style");
            style.innerHTML = `
              @keyframes progressBar {
                0% { width: 0% }
                50% { width: 100% }
                100% { width: 0% }
              }
            `;
            document.head.appendChild(style);
          },
        });

        perfMark("transfer:start");
        const response = await api.get(`/vehicle_transfer_details`, { params: { sno } });
        perfMark("transfer:end");
        perfMeasure("fetch vehicle_transfer_details", "transfer:start", "transfer:end");
        log("Fetched Vehicle Data:", response.data);

        if (response.data && response.data.transferDetails) {
          const items = response.data.transferDetails;
          const f = {
            vcode: items[0].vehicle_code || "",
            insertDate: items[0].insert_time || "",
            vnumber: items[0].vehicle_number || "",
            vname: items[0].vehicle_name || "",
            vehicleBranch: items[0].branch_code || "",
            vehicle_make: items[0].vehicle_make || "",
            model: items[0].model || "",
            invoiceNo: items[0].vehicle_invoice || "",
            vehicle_type: items[0].vehicle_type || "",
            vehicle_basis: items[0].vehicle_basis || "",
            chassis_num: items[0].chassis_num || "",
            engine_SlNo: items[0].engine_SlNo || "",
            vehicle_regdate: items[0].vehicle_regdate || "",
            vehicle_regno: items[0].vehicle_regno || "",
            purchase_date: items[0].purchase_date || "",
            vehicle_purfrom: items[0].vehicle_purfrom || "",
            Hypothecation: items[0].Hypothecation || "",
            purchese_amt: items[0].purchese_amt || "",
            insurance_date: items[0].insurance_date || "",
            renewal_date: items[0].renewal_date || "",
            insurance_number: items[0].insurance_number || "",
            insurance_amt: items[0].insurance_amt || "",
            premium_your: items[0].premium_your || "",
            insurance_company: items[0].insurance_company || "",
            Fc_date: items[0].Fc_date || "",
            Fc_renewaldate: items[0].Fc_renewaldate || "",
            rc_number: items[0].rc_number || "",
            permit_expirydate: items[0].permit_expirydate || "",
            permit_date: items[0].permit_date || "",
            roadtax_to: items[0].roadtax_to || "",
            roadtax_from: items[0].roadtax_from || "",
            cumulative: items[0].cumulative || "",
            vehicle_description: items[0].vehicle_description || "",
            fld_equipment: items[0].fld_equipment || "",
            fld_utilisation: items[0].fld_utilisation || "",
            fld_vehiclecondition: items[0].fld_vehiclecondition || "",
            remarks: items[0].remarks || "",
            hyp_exp_date: items[0].hyp_exp_date || "",
          };
          log("Setting formData:", f);
          setFormData(f);
        }
        Swal.close();
      } catch (error) {
        Swal.close();
        err("Error fetching Vehicle Details:", error);
        Swal.fire({
          icon: "error",
          title: "Oops!",
          text: "Error fetching Vehicle Details. Please try again",
        });
      }
    };
    fetchStnDetails();
  }, [sno]);

  /* ---------------------------- FORM LOGIC ---------------------------- */
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    log("change:", name, "=>", value);
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  // Map keys -> human labels
  const LABELS = {
    user: "User",
    vcode: "Vehicle Code",
    insertDate: "Insert Date",
    vehicleBranch: "Vehicle Branch",
    invoiceNo: "Invoice No",
    vname: "Vehicle Name",
    vnumber: "Vehicle Number",
    vehicle_make: "Vehicle Make",
    model: "Model",
    vehicle_type: "Vehicle Type",
    vehicle_basis: "Vehicle Basis",
    chassis_num: "Chassis No",
    engine_SlNo: "Engine Sl.No",
    vehicle_regno: "Vehicle Reg No",
    vehicle_regdate: "Vehicle Reg Date",
    vehicle_purfrom: "Purchased From",
    purchase_date: "Purchase Date",
    Hypothecation: "Hypothecation",
    purchese_amt: "Purchase Amount",
    insurance_date: "Insurance Date",
    renewal_date: "Insurance Renewal Date",
    insurance_number: "Insurance Number",
    insurance_amt: "Insurance Amount",
    premium_your: "Premium Year",
    insurance_company: "Insurance Company",
    Fc_date: "FC Date",
    Fc_renewaldate: "FC Renewal Date",
    rc_number: "RC Number",
    hyp_exp_date: "Hypothecation Expiry",
    permit_date: "Permit Date",
    permit_expirydate: "Permit Expiry Date",
    roadtax_from: "Road Tax From",
    roadtax_to: "Road Tax To",
    vehicle_description: "Vehicle Description",
    fld_equipment: "Equipment",
    fld_utilisation: "Utilisation",
    fld_vehiclecondition: "Vehicle Condition",
    cumulative: "Cumulative",
    remarks: "Remarks",
  };

  const isEmpty = (v) => v === null || v === undefined || String(v).trim() === "";
  const focusField = (key) => {
    const el = document.getElementById(key);
    if (el && typeof el.focus === "function") {
      el.focus();
      if (el.setSelectionRange && typeof el.value === "string") {
        const len = el.value.length;
        el.setSelectionRange(len, len);
      }
    } else {
      warn("focusField could not find element with id:", key);
    }
  };

  const REQUIRED_IN_ORDER = [
    "vcode",
    "insertDate",
    "vehicleBranch",
    "invoiceNo",
    "vname",
    "vnumber",
    "vehicle_make",
    "model",
    "vehicle_type",
    "vehicle_basis",
    "chassis_num",
    "engine_SlNo",
    "vehicle_regno",
    "vehicle_regdate",
    "vehicle_purfrom",
    "purchase_date",
    "Hypothecation",
    "purchese_amt",
    "insurance_date",
    "renewal_date",
    "insurance_number",
    "insurance_amt",
    "premium_your",
    "insurance_company",
    "Fc_date",
    "Fc_renewaldate",
    "rc_number",
    "hyp_exp_date",
    "permit_date",
    "permit_expirydate",
    "roadtax_from",
    "roadtax_to",
    "vehicle_description",
    "fld_equipment",
    "fld_utilisation",
    "fld_vehiclecondition",
    "cumulative",
    "remarks",
  ];

  const handleSubmit = async (e) => {
    e.preventDefault();
    log("SUBMIT start with formData:", formData);

    // required checks
    for (const key of REQUIRED_IN_ORDER) {
      if (isEmpty(formData[key])) {
        warn("required failed:", key);
        await Swal.fire({
          icon: "warning",
          title: `${LABELS[key] || key} is required`,
          text: `Please enter ${LABELS[key]?.toLowerCase() || key}.`,
        });
        focusField(key);
        return;
      }
    }

    // cumulative checks
    const raw = formData.cumulative;
    const validatedCumulative = Number(raw);
    if (!Number.isFinite(validatedCumulative)) {
      warn("cumulative not a number:", raw);
      await Swal.fire({ icon: "error", title: "Invalid Input", text: "Cumulative value must be a valid number." });
      focusField("cumulative");
      return;
    }
    if (validatedCumulative < 0) {
      warn("cumulative negative:", validatedCumulative);
      await Swal.fire({ icon: "error", title: "Invalid Input", text: "Cumulative value cannot be negative." });
      focusField("cumulative");
      return;
    }
    const digitsOnly = String(raw).replace(".", "");
    if (digitsOnly.length > 6) {
      warn("cumulative too long:", raw);
      await Swal.fire({
        icon: "warning",
        title: "Invalid Length",
        text: "Cumulative value cannot be more than 6 digits (excluding decimal point).",
      });
      focusField("cumulative");
      return;
    }

    // submit
    try {
      // await Swal.fire({
      //   title: "Submitting...",
      //   text: "Please wait while we process your request.",
      //   allowOutsideClick: false,
      //   didOpen: () => Swal.showLoading(),
      // });

      const payload = {
        user,
        vcode: formData.vcode,
        insertDate: formData.insertDate,
        vehicleBranch: formData.vehicleBranch,
        invoiceNo: formData.invoiceNo,
        vname: formData.vname,
        vnumber: formData.vnumber,
        vehicle_make: formData.vehicle_make,
        model: formData.model,
        vehicle_type: formData.vehicle_type,
        vehicle_basis: formData.vehicle_basis,
        chassis_num: formData.chassis_num,
        engine_SlNo: formData.engine_SlNo,
        vehicle_regno: formData.vehicle_regno,
        vehicle_regdate: formData.vehicle_regdate,
        vehicle_purfrom: formData.vehicle_purfrom,
        purchase_date: formData.purchase_date,
        Hypothecation: formData.Hypothecation,
        purchese_amt: formData.purchese_amt,
        insurance_date: formData.insurance_date,
        renewal_date: formData.renewal_date,
        insurance_number: formData.insurance_number,
        insurance_amt: formData.insurance_amt,
        premium_your: formData.premium_your,
        insurance_company: formData.insurance_company,
        Fc_date: formData.Fc_date,
        Fc_renewaldate: formData.Fc_renewaldate,
        rc_number: formData.rc_number,
        hyp_exp_date: formData.hyp_exp_date,
        permit_date: formData.permit_date,
        permit_expirydate: formData.permit_expirydate,
        roadtax_from: formData.roadtax_from,
        roadtax_to: formData.roadtax_to,
        vehicle_description: formData.vehicle_description,
        fld_equipment: formData.fld_equipment,
        fld_utilisation: formData.fld_utilisation,
        fld_vehiclecondition: formData.fld_vehiclecondition,
        cumulative: validatedCumulative,
        remarks: formData.remarks,
      };

      log("PUT payload:", payload);
      perfMark("update:start");
      const response = await api.put(`/ownVeh_details_edit/${sno}`, payload);
      perfMark("update:end");
      perfMeasure("PUT ownVeh_details_edit", "update:start", "update:end");

      if (response.data?.success) {
        log("Update success:", response.data);
        await Swal.fire({ title: "Success!", text: "Vehicle Details Updated Successfully.", icon: "success" });
        navigate(`/vehicle_details_view/${sno}`);
      } else {
        warn("Update failed:", response.data);
        await Swal.fire({
          icon: "error",
          title: "Update failed",
          text: response.data?.error || "Failed to update vehicle details.",
        });
      }
    } catch (error) {
      const timedOut = error?.code === "ECONNABORTED";
      err("SUBMIT error:", error);
      await Swal.fire({
        icon: "error",
        title: timedOut ? "Request timed out" : "Submission failed",
        text: timedOut
          ? "The server took too long to respond. Please try again."
          : error?.response?.data?.error || "An error occurred while updating the vehicle details.",
      });
    } finally {
      Swal.close();
      log("SUBMIT end");
    }
  };

  /* ------------------------------- UI ------------------------------- */
  return (
    <div id="admin-container">
      <AdminNav />
      <div className="content-right">
        <section>
          <div className="back-div">
            <h2 className="add-txt">Vehicle Details Edit</h2>
            <p className="back-button" onClick={() => navigate(-1)} style={{ cursor: "pointer" }}>
              <i className="fa-solid fa-backward"></i> Back
            </p>
          </div>
          <Time />
        </section>

        <div className="form-container">
          <form className="vehicle-form" onSubmit={handleSubmit}>
            <div className="form-row">
              <div className="form-group">
                <label>Vehicle Code :</label>
                <input id="vcode" type="text" name="vcode" value={formData.vcode || ""} readOnly />
              </div>
              <div className="form-group">
                <label>Entry Date :</label>
                <input
                  id="insertDate"
                  type="text"
                  value={formData.insertDate ? new Date(formData.insertDate).toLocaleDateString("en-GB") : ""}
                  readOnly
                />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Vehicle Branch :</label>
                <select
                  id="vehicleBranch"
                  name="vehicleBranch"
                  value={formData.vehicleBranch || ""}
                  onChange={handleInputChange}
                >
                  {branches.map((item, index) => (
                    <option key={index} value={item.branchMaster_code}>
                      {item.branchMaster_name}
                    </option>
                  ))}
                </select>
              </div>

              <div className="form-group">
                <label>Invoice Number :</label>
                <input id="invoiceNo" type="text" name="invoiceNo" value={formData.invoiceNo || ""} onChange={handleInputChange} />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Vehicle Name :</label>
                <input id="vname" type="text" name="vname" value={formData.vname || ""} onChange={handleInputChange} />
              </div>
              <div className="form-group">
                <label>Vehicle Number :</label>
                <input id="vnumber" type="text" name="vnumber" value={formData.vnumber || ""} onChange={handleInputChange} />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Vehicle Make :</label>
                <input id="vehicle_make" type="text" name="vehicle_make" value={formData.vehicle_make || ""} onChange={handleInputChange} />
              </div>
              <div className="form-group">
                <label>Model :</label>
                <input id="model" type="text" name="model" value={formData.model || ""} onChange={handleInputChange} />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Vehicle Type:</label>
                <select id="vehicle_type" name="vehicle_type" value={formData.vehicle_type || ""} onChange={handleInputChange}>
                  {vehicleType.map((item, index) => (
                    <option key={index} value={item.fld_vehiclename}>
                      {item.fld_vehiclename}
                    </option>
                  ))}
                </select>
              </div>
              <div className="form-group">
                <label>Vehicle Basis :</label>
                <select id="vehicle_basis" name="vehicle_basis" value={formData.vehicle_basis || ""} onChange={handleInputChange}>
                  <option value="">-Select-</option>
                  <option value="Hour">Hour</option>
                  <option value="Km">KM</option>
                </select>
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Chassis Number:</label>
                <input id="chassis_num" type="text" name="chassis_num" value={formData.chassis_num || ""} onChange={handleInputChange} />
              </div>
              <div className="form-group">
                <label>Engine SL.No :</label>
                <input id="engine_SlNo" type="text" name="engine_SlNo" value={formData.engine_SlNo || ""} onChange={handleInputChange} />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Vehicle Reg Number:</label>
                <input id="vehicle_regno" type="text" name="vehicle_regno" value={formData.vehicle_regno || ""} onChange={handleInputChange} />
              </div>
              <div className="form-group">
                <label>Vehicle Reg date:</label>
                <input
                  id="vehicle_regdate"
                  type="date"
                  name="vehicle_regdate"
                  value={formData.vehicle_regdate ? new Date(formData.vehicle_regdate).toISOString().split("T")[0] : ""}
                  onChange={handleInputChange}
                />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Purchased From:</label>
                <input id="vehicle_purfrom" type="text" name="vehicle_purfrom" value={formData.vehicle_purfrom || ""} onChange={handleInputChange} />
              </div>
              <div className="form-group">
                <label>Purchased date:</label>
                <input
                  id="purchase_date"
                  type="date"
                  name="purchase_date"
                  value={formData.purchase_date ? new Date(formData.purchase_date).toISOString().split("T")[0] : ""}
                  onChange={handleInputChange}
                />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Hypothecation with:</label>
                <input id="Hypothecation" type="text" name="Hypothecation" value={formData.Hypothecation || ""} onChange={handleInputChange} />
              </div>
              <div className="form-group">
                <label>Purchased Amount:</label>
                <input id="purchese_amt" type="text" name="purchese_amt" value={formData.purchese_amt || ""} onChange={handleInputChange} />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Insurance date:</label>
                <input
                  id="insurance_date"
                  type="date"
                  name="insurance_date"
                  value={formData.insurance_date ? new Date(formData.insurance_date).toISOString().split("T")[0] : ""}
                  onChange={handleInputChange}
                />
              </div>
              <div className="form-group">
                <label>Insurance Renewal date:</label>
                <input
                  id="renewal_date"
                  type="date"
                  name="renewal_date"
                  value={formData.renewal_date ? new Date(formData.renewal_date).toISOString().split("T")[0] : ""}
                  onChange={handleInputChange}
                />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Insurance Number:</label>
                <input id="insurance_number" type="text" name="insurance_number" value={formData.insurance_number || ""} onChange={handleInputChange} />
              </div>
              <div className="form-group">
                <label>Insured amount:</label>
                <input id="insurance_amt" type="text" name="insurance_amt" value={formData.insurance_amt || ""} onChange={handleInputChange} />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Ins. Premium Per Year:</label>
                <input id="premium_your" type="text" name="premium_your" value={formData.premium_your || ""} onChange={handleInputChange} />
              </div>
              <div className="form-group">
                <label>Insurance Company:</label>
                <input id="insurance_company" type="text" name="insurance_company" value={formData.insurance_company || ""} onChange={handleInputChange} />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>FC Date:</label>
                <input id="Fc_date" type="date" name="Fc_date" value={formData.Fc_date ? new Date(formData.Fc_date).toISOString().split("T")[0] : ""} onChange={handleInputChange} />
              </div>

              <div className="form-group">
                <label>FC Renewal Date:</label>
                <input
                  id="Fc_renewaldate"
                  type="date"
                  name="Fc_renewaldate"
                  value={formData.Fc_renewaldate ? new Date(formData.Fc_renewaldate).toISOString().split("T")[0] : ""}
                  onChange={handleInputChange}
                />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>RC Book Number:</label>
                <input id="rc_number" type="text" name="rc_number" value={formData.rc_number || ""} onChange={handleInputChange} />
              </div>
              <div className="form-group">
                <label> Hyp. Expiry date :</label>
                <input
                  id="hyp_exp_date"
                  type="date"
                  name="hyp_exp_date"
                  value={formData.hyp_exp_date ? new Date(formData.hyp_exp_date).toISOString().split("T")[0] : ""}
                  onChange={handleInputChange}
                />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Permit date:</label>
                <input
                  id="permit_date"
                  type="date"
                  name="permit_date"
                  value={formData.permit_date ? new Date(formData.permit_date).toISOString().split("T")[0] : ""}
                  onChange={handleInputChange}
                />
              </div>
              <div className="form-group">
                <label>Permit Expire date:</label>
                <input
                  id="permit_expirydate"
                  type="date"
                  name="permit_expirydate"
                  value={formData.permit_expirydate ? new Date(formData.permit_expirydate).toISOString().split("T")[0] : ""}
                  onChange={handleInputChange}
                />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Road Tax From Date:</label>
                <input
                  id="roadtax_from"
                  type="date"
                  name="roadtax_from"
                  value={formData.roadtax_from ? new Date(formData.roadtax_from).toISOString().split("T")[0] : ""}
                  onChange={handleInputChange}
                />
              </div>
              <div className="form-group">
                <label>Road Tax To Date:</label>
                <input
                  id="roadtax_to"
                  type="date"
                  name="roadtax_to"
                  value={formData.roadtax_to ? new Date(formData.roadtax_to).toISOString().split("T")[0] : ""}
                  onChange={handleInputChange}
                />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Vehicle description:</label>
                <input
                  id="vehicle_description"
                  type="text"
                  name="vehicle_description"
                  value={formData.vehicle_description || ""}
                  onChange={handleInputChange}
                />
              </div>
              <div className="form-group">
                <label>Vehicle Equipment Type:</label>
                <select id="fld_equipment" name="fld_equipment" value={formData.fld_equipment || ""} onChange={handleInputChange}>
                  {equip.map((item, index) => (
                    <option key={index} value={item.fld_type}>
                      {item.fld_type}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Utilisation:</label>
                <select id="fld_utilisation" name="fld_utilisation" value={formData.fld_utilisation || ""} onChange={handleInputChange}>
                  <option value="">-Select-</option>
                  <option value="Excellent">Excellent</option>
                  <option value="Good">Good</option>
                  <option value="Pair">Fair</option>
                  <option value="Poor">Poor</option>
                </select>
              </div>
              <div className="form-group">
                <label>Vehicle Condition:</label>
                <select
                  id="fld_vehiclecondition"
                  name="fld_vehiclecondition"
                  value={formData.fld_vehiclecondition || ""}
                  onChange={handleInputChange}
                >
                  <option value="">-Select-</option>
                  <option value="EWC-Excellent Working Condition">EWC</option>
                  <option value="GWC-Good Working Condition">GWC</option>
                  <option value="RMnR-Requiring Minor Repaired Parts">RMnR</option>
                  <option value="RMrR-Requiring Major Repaired Parts">RMrR</option>
                  <option value="Uc-Uncondition vehicle">Uncondition</option>
                </select>
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Remarks :</label>
                <input id="remarks" type="text" name="remarks" value={formData.remarks || ""} onChange={handleInputChange} />
              </div>
              <div className="form-group">
                <label>Current Cum HMR :</label>
                <input id="cumulative" type="text" name="cumulative" value={formData.cumulative || ""} onChange={handleInputChange} />
              </div>
            </div>

            <div className="btn-cls">
              <button type="submit" className="submit-btn">Update</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Vehicle_details_edit1;
